import { getConfigBaseUrl, getConfigGraphBaseUrl } from '../../../services/apiService';
import { getCounterpartyId } from '../../../services/authService';
import { apiCall, createApiThunk, graphqlCall } from '../../../utils/api';
import { print } from 'graphql';
import { getMyClientsQuery } from './myClientsQueries';

export const getMyClientsThunk = createApiThunk('GET_MY_CLIENTS', graphqlCall);
export const getSelectedClientThunk = createApiThunk('GET_SELECTED_CLIENT', apiCall);
export const getBasketRoutingOptionsThunk = createApiThunk('GET_BASKET_ROUTING_OPTIONS', apiCall);
export const editClientThunk = createApiThunk('EDIT_CLIENT', apiCall);
export const createClientThunk = createApiThunk('CREATE_CLIENT', apiCall);
export const deleteClientThunk = createApiThunk('DELETE_CLIENT', apiCall);

export const getMyClients = () => {
  const url = getConfigGraphBaseUrl();
  const query = print(getMyClientsQuery);
  return function (dispatch: AppDispatch) {
    dispatch(getMyClientsThunk({ url, query }));
  };
};

export const getSelectedClient = (clientId: string) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenant/${getCounterpartyId()}/client/${clientId}`;
  return dispatch(getSelectedClientThunk({ url, method: 'GET' }));
};
export const getBasketRoutingOptions = () => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/lookup-tables`;
  return dispatch(getBasketRoutingOptionsThunk({ url, method: 'GET' }));
};

export const editClient = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/client`;
  const method = 'PUT';
  return dispatch(editClientThunk({ url, method, data }));
};

export const createClient = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/client`;
  const method = 'POST';
  return dispatch(createClientThunk({ url, method, data }));
};

export const deleteClient = (clientId: string) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/clients/${clientId}`;
  const method = 'DELETE';
  return dispatch(deleteClientThunk({ url, method }));
};
